import React, { useEffect } from "react";
import { Box } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import styled from "styled-components";
import MyHome from "../../Components/Screens/Activity/MyHome";
import Dashboard from "../../Components/Screens/Activity/MyDashBoard";
import CustomIconButton from "../../Components/Button/CustomIconButton";
import { CustomTab, TabPanel } from "../../Components/CustomTab";
import { useThemes } from "../../Theme";

const Activity: React.FC = () => {
  const [value, setValue] = React.useState(0);
  const theme = useThemes();

  useEffect(() => {
    const bgColors = [
      theme.backgroundTab.main,
      theme.backgroundTab.main,
      theme.backgroundTab.main,
      theme.backgroundTab.main,
    ];
    document.body.style.backgroundColor = bgColors[value];
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [value]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [value]);

  const tabLabels = ["My Home", "My Dashboard"];
  const tabComponent = [<MyHome />, <Dashboard />];

  return (
    <>
      <Box
        sx={{
          bgcolor: "background.paper",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          position: "fixed",
          zIndex: 10,
          height: "72px",
          mt: 1,
        }}
      >
        <Box sx={{ padding: "10px 0 0 0" }}>
          <CustomTab tabs={tabLabels} value={value} setValue={setValue} />
        </Box>
        {/* <Box sx={{ display: "flex", alignItems: "center" }}>
          {(value === 2 || value === 3) && (
            <>
              <Typography
                onClick={handleOpen}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  pr: 1,
                  fontWeight:400,
                  fontSize: "14px",
                  marginTop: "10px",
                }}
              >
                {LearningCourse[LearningValue].course} &nbsp;
                <ArrowDropDownIcon sx={{ color:  "info.main" }} />
              </Typography>
              <Divider
                className="tab"
                sx={{ marginLeft: "20px", marginTop: "10px", color:  "info.main" }}
              />
            </>
          )} */}

        <IconBox>
          <CustomIconButton
            style={{ margin: "0px 5px" }}
            variant="secondary"
            icon={AddCircleIcon}
            disable
          />
        </IconBox>
        {/* </Box> */}
      </Box>
      {tabComponent.map((component, index) => (
        <TabPanel value={value} index={index} key={index}>
          <br />
          <br />
          {component}
        </TabPanel>
      ))}

      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          {LearningCourse.map((course, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                dispatch(changeLearningValue(index));
                handleClose();
              }}
            >
              {course.course}
            </MenuItem>
          ))}
        </Box>
      </Modal> */}
    </>
  );
};

export default Activity;

const IconBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 90px 0 30px;
`;
